/* CAFFREY help pages: FAQ search + insole size finder. Claude Code (launch foundation 3), 2026-10-06.
   Progressive enhancement only: every answer, chart and size list is server-rendered and works without this file. */
(() => {
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();

  /* ---------- FAQ search ---------- */
  document.querySelectorAll('[data-cf-faq]').forEach((root) => {
    const tools = root.querySelector('[data-cf-faq-tools]');
    const input = root.querySelector('[data-cf-faq-search]');
    if (!tools || !input) return;
    tools.hidden = false;
    const items = [...root.querySelectorAll('.cf-faq-item')];
    const groups = [...root.querySelectorAll('.cf-faq-group')];
    const status = root.querySelector('[data-cf-faq-status]');
    const empty = root.querySelector('[data-cf-faq-empty]');
    const text = items.map((it) => norm(it.textContent));
    let timer;
    const run = () => {
      const q = norm(input.value);
      const words = q ? q.split(' ') : [];
      let shown = 0;
      items.forEach((it, i) => {
        const hit = !words.length || words.every((w) => text[i].includes(w));
        it.hidden = !hit;
        if (hit) shown += 1;
        if (hit && q.length > 2 && !it.open) { it.open = true; it.dataset.cfAuto = '1'; }
        if ((!q || !hit) && it.dataset.cfAuto) { it.open = false; delete it.dataset.cfAuto; }
      });
      groups.forEach((g) => { g.hidden = !g.querySelector('.cf-faq-item:not([hidden])'); });
      if (empty) empty.hidden = shown > 0;
      if (status) status.textContent = q ? `${shown} ${shown === 1 ? root.dataset.one : root.dataset.many}` : '';
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 120); });
    input.addEventListener('search', run);
  });

  /* ---------- Size finder ---------- */
  document.querySelectorAll('[data-cf-size]').forEach((root) => {
    const dataEl = root.querySelector('script[data-cf-size-data]');
    const ui = root.querySelector('[data-cf-size-ui]');
    if (!dataEl || !ui) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const L = data.labels || {};
    const chart = data.chart || [];
    const select = ui.querySelector('select');
    const out = ui.querySelector('[data-cf-size-out]');
    const rows = [...root.querySelectorAll('[data-cf-size-row]')];
    ui.hidden = false;

    const euValues = () => {
      const set = new Set(chart.map((r) => r.eu));
      (data.products || []).forEach((p) => p.variants.forEach((v) => { for (let n = v.lo; n <= v.hi; n += 1) if (n >= 30 && n <= 50) set.add(n); }));
      return [...set].sort((a, b) => a - b);
    };
    const options = (sys) => {
      if (sys === 'w') return chart.filter((r) => r.w != null).map((r) => ({ v: r.w, t: `${L.women} ${r.w}` }));
      if (sys === 'm') return chart.filter((r) => r.m != null).map((r) => ({ v: r.m, t: `${L.men} ${r.m}` }));
      return euValues().map((n) => ({ v: n, t: `EU ${n}` }));
    };
    const sysNow = () => (ui.querySelector('input[name="cf-sz-sys"]:checked') || {}).value || 'eu';
    let lastEu = null;

    const fill = () => {
      const sys = sysNow();
      const opts = options(sys);
      const keep = lastEu != null ? chart.find((r) => r.eu === lastEu) : null;
      const want = keep ? (sys === 'w' ? keep.w : sys === 'm' ? keep.m : keep.eu) : (sys === 'eu' ? lastEu : null);
      select.innerHTML = '';
      const ph = document.createElement('option');
      ph.value = ''; ph.textContent = L.choose; select.appendChild(ph);
      opts.forEach((o) => {
        const el = document.createElement('option');
        el.value = String(o.v); el.textContent = o.t;
        if (want != null && o.v === want) el.selected = true;
        select.appendChild(el);
      });
      render();
    };

    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    const render = () => {
      const sys = sysNow();
      const val = select.value === '' ? null : Number(select.value);
      rows.forEach((r) => r.classList.remove('is-on'));
      if (val == null) { out.innerHTML = `<p class="cf-pg-small">${esc(L.prompt)}</p>`; lastEu = null; return; }
      const row = sys === 'eu' ? chart.find((r) => r.eu === val) : chart.find((r) => (sys === 'w' ? r.w : r.m) === val);
      const eu = sys === 'eu' ? val : (row ? row.eu : null);
      lastEu = eu;
      if (eu != null) rows.forEach((r) => { if (Number(r.dataset.cfSizeRow) === eu) r.classList.add('is-on'); });
      const w = row && row.w != null ? row.w : '—';
      const m = row && row.m != null ? row.m : '—';
      const matches = [];
      (data.products || []).forEach((p) => {
        let target = eu;
        if (sys === 'm' && p.mOff) target = val + p.mOff;
        if (sys === 'w' && p.wOff) target = val + p.wOff;
        if (target == null) return;
        const v = p.variants.find((x) => x.lo <= target && target <= x.hi);
        if (v) matches.push({ p, v, own: (sys === 'm' && p.mOff) || (sys === 'w' && p.wOff) });
      });
      let html = `<dl class="cf-sz-out__big"><div><dt>EU</dt><dd>${eu != null ? eu : '—'}</dd></div><div><dt>${esc(L.women)}</dt><dd>${w}</dd></div><div><dt>${esc(L.men)}</dt><dd>${m}</dd></div></dl>`;
      html += `<p class="cf-sz-out__note cf-pg-small">${esc(row ? L.approx : L.offchart)}</p>`;
      if (matches.length) {
        html += `<div class="cf-sz-matches"><h3>${esc(L.matches)}</h3>`;
        matches.forEach(({ p, v, own }) => {
          const sold = v.available ? '' : ` · ${esc(L.soldout)}`;
          const ownNote = own ? ` · ${esc(L.ownchart)}` : '';
          html += `<a href="${esc(p.url)}?variant=${v.id}"><strong>${esc(p.name)}</strong><span>EU ${esc(v.label.replace('-', '–'))}${ownNote}${sold}</span></a>`;
        });
        html += '</div>';
      } else {
        html += `<p class="cf-pg-small" style="margin-top:14px">${esc(L.nomatch)}</p>`;
      }
      out.innerHTML = html;
    };

    ui.querySelectorAll('input[name="cf-sz-sys"]').forEach((r) => r.addEventListener('change', fill));
    select.addEventListener('change', render);
    fill();
  });
})();
